import PropTypes from 'prop-types';
import { BookingOrderSummary } from 'components/BookingOrderSummary/BookingOrderSummary';
import { ReactComponent as IconPrint } from 'assets/icons/svgs/icon-print.svg';
import { Link } from 'components/UI/Link/Link';
import './BookingConfirmation.scss';
import { printReceipt } from './booking-confirmation-utils';

export const BookingConfirmation = (props) => {
  const { Order, OrderDataLayer, allowRemove } = props;
  const handlePrint = () => {
    const printContainer = document.getElementById('orderSideSummary');

    // Prevent error when the print element does not exist
    if (!printContainer) return null;

    const contentToPrint = printContainer.innerHTML;
    printReceipt(contentToPrint);
  };

  return (
    <>
      <BookingOrderSummary Order={Order} OrderDataLayer={OrderDataLayer} allowRemove={allowRemove} />

      <div className="cart-print-receipt text-center hidden-print">
        <Link
          href="#"
          noUnderline
          onClick={handlePrint}
          variant="secondary"
          extendClass="link-bold print-receipt-btn"
          startIcon={<IconPrint />}
        >
          Print receipt
        </Link>
      </div>
    </>
  );
};

BookingConfirmation.propTypes = {
  Order: PropTypes.object.isRequired,
  OrderDataLayer: PropTypes.object.isRequired,
  allowRemove: PropTypes.bool,
};

/**
 * Setting allowRemove to be false by default but can be changed on razor template
 */
BookingConfirmation.defaultProps = {
  allowRemove: false,
};

export const BookingConfirmationSC = (props) => {
  const { sitecoreData } = props;
  return <BookingConfirmation {...sitecoreData} />;
};

BookingConfirmationSC.propTypes = {
  sitecoreData: PropTypes.object,
};
